export function LoginToken(res) {
    return { type: 'LoginToken', res };
}

export function LoginRole(res) {
    return { type: 'LoginRole', res };
}

export function LoginAdminByID(res) {
    return { type: 'LoginAdminByID', res };
}

export function GetPartner(res) {
    return { type: 'GetPartner', res };
}

export function GetPartnerEvent(res) {
    return { type: 'GetPartnerEvent', res };
}
export function GetSatellite(res) {
    return { type: 'GetSatelliteScreen', res };
}

export function GetSatelliteEvent(res) {
    return { type: 'GetGetSatelliteScreenEvent', res };
}

export function ProfileName(res) {
    return { type: 'ProfileName', res };
}

export function LoginUser(res) {
    return { type: 'LoginUser', res };
}

export function BackToAdminFlag(res) {
    return { type: 'BackToAdminFlag', res };
}
export function BackToAdminPreviousPath(res) {
    return { type: 'BackToAdminPreviousPath', res };
}

export function ProductEditList(res) {
    return { type: 'ProductEditList', res };
}
export function EmailEditList(res) {
    return { type: 'EmailEditList', res };
}
export function StoreProductEditList(res) {
    return { type: 'StoreProductEditList', res };
}

export function CouponEditList(res) {
    return { type: 'CouponEditList', res };
}
export function filmEditData(res) {
    return { type: 'filmEditData', res };
}
export function LocationEditData(res) {
    return { type: 'locationEditData', res };
}

// export function LocationEditData(res) {
//     return { type: 'locationEditData', res };
// }

export function TalkEventEditData(res) {
    return { type: 'TalkEventEditData', res };
}
export function NotificationEditData(res) {
    return { type: 'NotificationEditData', res };
}
export function NewFrontierEditData(res) {
    return { type: 'NewFrontierEditData', res };
}

export function LiveSceeringEditData(res) {
    return { type: 'LiveSceeringEditData', res };
}

export function PartnerEventsEditData(res) {
    return { type: 'PartnerEventsEditData', res };
}

export function OtherEventsEditData(res) {
    return { type: 'OtherEventsEditData', res };
}

export function ShortProgramEditData(res) {
    return { type: 'ShortProgramEditData', res };
}
export function EpisodicShortProgramEditData(res) {
    return { type: 'EpisodicShortProgramEditData', res };
}

export function CurrentTab(res) {
    return { type: 'CurrentTab', res };
}
export function CurrentShortTab(res) {
    return { type: 'CurrentShortTab', res };
}
export function Searchvalue(res) {
    return { type: 'Searchvalue', res };
}

export function searchLocation(res) {
    return { type: 'searchLocation', res };
}
export function GetHighlightTable(res)  {
    return {type :'HighlightTable',payload:res};
}
export function GetHighlightEdit(res) {
    return { type: 'HighlightEdit', payload: res };
}
export function GetPrivateEventTable(res) {
    return { type: 'PrivateEventTable', payload: res };
}
export function GetPrivateEventEdit(res) {
    return { type: 'PrivateEventEdit', payload: res };
}
export function ScannerLoginData(res) {
    return { type: 'ScannerLoginData', res };
}
export function FpgLocked(res) {
    return { type: 'FpgLocked', res };
}
export function MemberShipEditList(res) {
    return { type: 'MemberShipEditList', res };
}
export function PostAcceptanceEditList(res) {
    return { type: 'PostAcceptanceEditList', res };
}
export function titleProjectInfo(res) {
    return { type: 'titleProjectInfo', res };
}
export function Countries(res) {
    return { type: 'Countries', res };
}
export function PageTakeoverEditData(res) {
    return { type: 'PageTakeoverEditData', res };
}

export function AccessControlEditData(res) {
    return { type: 'AccessControlEditData', res };
}

export function SetRecordViewers(res) {
    return { type: 'SetRecordViewers', res };
}
export function SetRecordConflict(res) {
    return { type: 'SetRecordConflict', res };
}
export function ClearRecordPresence() {
    return { type: 'ClearRecordPresence' };
}
export function AllInitial(res) {
    return { type: 'AllInitial', res };
}
export function PatchAllInitial(res) {
    return { type: 'PatchAllInitial', res };
}

// export function MemberShipEditList(res){
//     return{type: 'MemberShipEditList', res};
// }


